export default __webpack_public_path__ + "static/Poppins-SemiBold-ee8ae013a422a80622c60c305ea0a6b7.woff";